<div class="container-fluid platformPage py-3">
  <div class="row">

    <!-- -------------------------------------------------------------------- -->
    <!--                             ANCHOR HEADER                            -->
    <!-- -------------------------------------------------------------------- -->
    <div class="col-12 mb-3">

      <!-- Un solo row: el responsive se resuelve con col-lg-*, no abriendo
           filas extra. -->
      <div class="row g-2 align-items-center">

        <div class="col-auto">
          <a
            [routerLink]="['../']"
            class="btn btn-light rounded-circle platformPage__iconBtn"
            aria-label="Volver al listado de plataformas"
            title="Volver">
            <i class="material-icons" aria-hidden="true">arrow_back</i>
          </a>
        </div>

        <div class="col placeholder-glow">
          @if (loading) {
            <span
              class="placeholder col-6 rounded d-block platformPage__skeletonTitle mb-2"
              aria-hidden="true">
            </span>
            <span
              class="placeholder col-4 rounded d-block platformPage__skeletonText"
              aria-hidden="true">
            </span>
          } @else if (platform) {
            <h1 class="platformPage__title text-truncate mb-1">{{ platform.sku }}</h1>
            @if (platform.appName) {
              <p class="platformPage__subtitle text-truncate mb-0">{{ platform.appName }}</p>
            } @else {
              <p class="platformPage__subtitleOff text-truncate mb-0">Sin nombre de app</p>
            }
          } @else {
            <h1 class="platformPage__title mb-0">Plataforma</h1>
          }
        </div>

        <div class="col-12 col-lg-auto">
          <div class="d-flex align-items-center justify-content-lg-end gap-2">

            @if (platform) {
              <button
                (click)="openPlatform()"
                type="button"
                class="btn btn-light rounded-circle platformPage__iconBtn"
                [attr.aria-label]="'Editar la plataforma ' + platform.sku"
                title="Editar plataforma">
                <i class="material-icons" aria-hidden="true">edit</i>
              </button>

              <button
                (click)="openFaqGroup()"
                type="button"
                class="btn btn-success rounded-circle platformPage__iconBtn"
                aria-label="Registrar un nuevo grupo de preguntas"
                title="Nuevo grupo">
                <i class="material-icons" aria-hidden="true">add</i>
              </button>
            }

            <button
              (click)="getData()"
              type="button"
              class="btn btn-primary rounded-circle platformPage__iconBtn"
              [disabled]="loading"
              aria-label="Actualizar la información de la plataforma"
              title="Actualizar">
              <i class="material-icons" aria-hidden="true">refresh</i>
            </button>

          </div>
        </div>

      </div>
    </div>

    <!-- -------------------------------------------------------------------- -->
    <!--                            ANCHOR NOT FOUND                          -->
    <!-- -------------------------------------------------------------------- -->
    @if (!loading && notFound) {

      <div class="col-12">
        <div class="platformPage__panel">
          <div class="platformPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
            <i class="material-icons platformPage__emptyIcon" aria-hidden="true">search_off</i>
            <p class="platformPage__emptyTitle mb-1">No pudimos cargar esta plataforma</p>
            <p class="platformPage__emptyText mb-3">
              Puede que ya no exista o que el servidor no haya respondido.
              Intenta de nuevo o vuelve al listado.
            </p>
            <div class="d-flex flex-wrap justify-content-center gap-2">
              <button
                (click)="getData()"
                type="button"
                class="btn btn-outline-primary platformPage__emptyBtn">
                Reintentar
              </button>
              <a
                [routerLink]="['../']"
                class="btn btn-light platformPage__emptyBtn">
                Ver todas las plataformas
              </a>
            </div>
          </div>
        </div>
      </div>

    }

    <!-- -------------------------------------------------------------------- -->
    <!--                             ANCHOR RESUMEN                           -->
    <!-- -------------------------------------------------------------------- -->
    @if (!notFound) {

      <div class="col-12 mb-4">
        <div class="row g-2 placeholder-glow">

          <div class="col-6 col-lg-3">
            <div class="platformPage__metric">
              <span class="platformPage__metricLabel d-block">Grupos</span>
              @if (loading) {
                <span class="placeholder col-4 rounded d-block platformPage__skeletonText" aria-hidden="true"></span>
              } @else {
                <span class="platformPage__metricValue d-block">{{ totalFaqGroups }}</span>
              }
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <div class="platformPage__metric">
              <span class="platformPage__metricLabel d-block">Preguntas</span>
              @if (loading) {
                <span class="placeholder col-4 rounded d-block platformPage__skeletonText" aria-hidden="true"></span>
              } @else {
                <span class="platformPage__metricValue d-block">{{ totalFaqs }}</span>
              }
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <div class="platformPage__metric">
              <span class="platformPage__metricLabel d-block">Visibles en la app</span>
              @if (loading) {
                <span class="placeholder col-4 rounded d-block platformPage__skeletonText" aria-hidden="true"></span>
              } @else {
                <!-- Dato derivado: va como texto de solo lectura, nunca dentro
                     de un campo editable. -->
                <span class="platformPage__metricValue d-block">{{ visibleFaqs }}</span>
              }
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <div class="platformPage__metric">
              <span class="platformPage__metricLabel d-block">Última actualización</span>
              @if (loading) {
                <span class="placeholder col-8 rounded d-block platformPage__skeletonText" aria-hidden="true"></span>
              } @else if (platform) {
                <span class="platformPage__metricDate d-block">
                  {{ platform.updatedAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                </span>
              }
            </div>
          </div>

        </div>
      </div>

      <!-- ------------------------------------------------------------------ -->
      <!--                        ANCHOR SECTION TITLE                        -->
      <!-- ------------------------------------------------------------------ -->
      <div class="col-12 mb-2">
        <div class="d-flex align-items-center justify-content-between gap-2">
          <h2 class="platformPage__sectionTitle mb-0">Grupos de preguntas</h2>
          <p class="platformPage__sectionHint mb-0 d-none d-lg-block">
            Cada grupo es un encabezado en la pantalla de Ayuda de la app.
          </p>
        </div>
      </div>

      <!-- ------------------------------------------------------------------ -->
      <!--                          ANCHOR SKELETON                           -->
      <!-- ------------------------------------------------------------------ -->
      @if (loading) {

        @for (skeletonGroup of skeletonGroups; track $index) {
          <div class="col-12 mb-3" aria-hidden="true">
            <div class="platformPage__group placeholder-glow">

              <div class="platformPage__groupHeader d-flex align-items-center gap-2">
                <span class="placeholder rounded-circle platformPage__skeletonIcon"></span>
                <span class="placeholder col-4 rounded platformPage__skeletonTitle"></span>
              </div>

              <div class="platformPage__groupBody">
                @for (skeletonFaq of skeletonFaqs; track $index) {
                  <div class="platformPage__faq">
                    <span class="placeholder col-7 rounded d-block platformPage__skeletonText mb-2"></span>
                    <span class="placeholder col-10 rounded d-block platformPage__skeletonText"></span>
                  </div>
                }
              </div>

            </div>
          </div>
        }

      }

      <!-- ------------------------------------------------------------------ -->
      <!--                           ANCHOR GROUPS                            -->
      <!-- ------------------------------------------------------------------ -->
      @if (!loading && platform) {

        <div class="col-12">

          <!-- Zona de arrastre propia y EXCLUSIVA de los grupos. El .row de la
               página también carga el encabezado, las métricas y el título de
               sección: marcarlo como cdkDropList habría vuelto arrastrables las
               tarjetas de resumen. -->
          <div
            cdkDropList
            cdkDropListLockAxis="y"
            [cdkDropListDisabled]="reorderingFaqGroupId !== null"
            (cdkDropListDropped)="dropFaqGroup($event)"
            class="platformPage__dropList">

            @for (faqGroup of platform.faqGroups; track faqGroup.faqGroupId) {

              <div
                cdkDrag
                cdkDragBoundary=".platformPage__dropList"
                cdkDragPreviewContainer="parent"
                (cdkDragEnded)="endFaqGroupDrag()"
                class="platformPage__dropItem mb-3">

                <!-- El grupo apagado se marca con borde gris + fondo apagado +
                     texto explícito. Nunca en rojo: no es un error, es que el
                     residente no lo ve. -->
                <div
                  class="platformPage__group"
                  [ngClass]="{ 'platformPage__group--off': !faqGroup.status }">

                  <div class="platformPage__groupHeader d-flex flex-wrap align-items-center gap-2">

                    <button
                      (click)="toggleGroup(faqGroup)"
                      type="button"
                      class="btn btn-light rounded-circle platformPage__iconBtn"
                      [attr.aria-expanded]="!isCollapsed(faqGroup)"
                      [attr.aria-controls]="'faqGroupBody' + faqGroup.faqGroupId"
                      [attr.aria-label]="(isCollapsed(faqGroup) ? 'Mostrar' : 'Ocultar') + ' las preguntas del grupo ' + faqGroup.title">
                      <i
                        class="material-icons platformPage__chevron"
                        [ngClass]="{ 'platformPage__chevron--collapsed': isCollapsed(faqGroup) }"
                        aria-hidden="true">
                        expand_more
                      </i>
                    </button>

                    <!-- ANCHOR DRAG HANDLE — el asa es el encabezado, no la
                         tarjeta completa: un grupo expandido con 15 preguntas
                         es altísimo y arrastrarlo entero es inmanejable. Deja
                         fuera el chevron y los botones de acción, así que
                         picarlos nunca arranca un arrastre. -->
                    <div
                      cdkDragHandle
                      (pointerdown)="startFaqGroupDrag()"
                      class="platformPage__dragHandle d-flex flex-wrap align-items-center gap-2"
                      title="Arrastra para reordenar este grupo">

                      <i class="material-icons platformPage__dragGrip" aria-hidden="true">drag_indicator</i>

                      <div class="d-flex flex-column platformPage__groupHeading">
                        <h3 class="platformPage__groupTitle text-truncate mb-0">{{ faqGroup.title }}</h3>
                        <span class="platformPage__groupMeta text-truncate">
                          {{ faqGroup.faqs.length }}
                          {{ faqGroup.faqs.length === 1 ? 'pregunta' : 'preguntas' }}
                          <span class="d-none d-lg-inline">
                            &middot; Actualizado {{ faqGroup.updatedAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                          </span>
                        </span>
                      </div>

                      <span
                        class="platformPage__badge"
                        [ngClass]="faqGroup.status ? 'platformPage__badge--on' : 'platformPage__badge--off'">
                        <i class="material-icons platformPage__badgeIcon" aria-hidden="true">
                          {{ faqGroup.status ? 'visibility' : 'visibility_off' }}
                        </i>
                        {{ faqGroup.status ? 'Visible en la app' : 'Oculto en la app' }}
                      </span>

                    </div>

                    <!-- Indicador discreto sobre la pieza que se movió, nunca
                         un overlay. El resultado lo anuncia la región viva de
                         la página, así que aquí va oculto al lector. -->
                    @if (reorderingFaqGroupId === faqGroup.faqGroupId) {
                      <span class="platformPage__saving" aria-hidden="true">
                        <span class="spinner-border spinner-border-sm"></span>
                        Guardando orden
                      </span>
                    }

                    <div class="d-flex align-items-center gap-2 ms-auto">

                      <!-- ANCHOR MOVE BUTTONS — único mecanismo de
                           reordenamiento operable por teclado y en táctil: ni
                           el CDK ni PrimeNG arrastran con teclado. En el
                           extremo NO llevan disabled (perderían el foco justo
                           al llegar ahí): se apagan en gris con aria-disabled y
                           el clic no mueve nada. -->
                      <button
                        #moveFaqGroupUpButton
                        (click)="moveFaqGroup($index, $index - 1, moveFaqGroupUpButton)"
                        type="button"
                        class="btn btn-light rounded-circle platformPage__iconBtn"
                        [ngClass]="{ 'platformPage__iconBtn--off': $first }"
                        [attr.aria-disabled]="$first ? 'true' : null"
                        [attr.aria-label]="'Subir el grupo ' + faqGroup.title"
                        [title]="$first ? 'Ya es el primer grupo' : 'Subir grupo'">
                        <i class="material-icons" aria-hidden="true">arrow_upward</i>
                      </button>

                      <button
                        #moveFaqGroupDownButton
                        (click)="moveFaqGroup($index, $index + 1, moveFaqGroupDownButton)"
                        type="button"
                        class="btn btn-light rounded-circle platformPage__iconBtn"
                        [ngClass]="{ 'platformPage__iconBtn--off': $last }"
                        [attr.aria-disabled]="$last ? 'true' : null"
                        [attr.aria-label]="'Bajar el grupo ' + faqGroup.title"
                        [title]="$last ? 'Ya es el último grupo' : 'Bajar grupo'">
                        <i class="material-icons" aria-hidden="true">arrow_downward</i>
                      </button>

                      <button
                        (click)="openFaq(faqGroup)"
                        type="button"
                        class="btn btn-success rounded-circle platformPage__iconBtn"
                        [attr.aria-label]="'Agregar una pregunta al grupo ' + faqGroup.title"
                        title="Agregar pregunta">
                        <i class="material-icons" aria-hidden="true">add</i>
                      </button>

                      <button
                        (click)="openFaqGroup(faqGroup)"
                        type="button"
                        class="btn btn-light rounded-circle platformPage__iconBtn"
                        [attr.aria-label]="'Editar el grupo ' + faqGroup.title"
                        title="Editar grupo">
                        <i class="material-icons" aria-hidden="true">edit</i>
                      </button>

                      <button
                        (click)="deleteFaqGroup(faqGroup)"
                        type="button"
                        class="btn btn-danger rounded-circle platformPage__iconBtn"
                        [attr.aria-label]="'Eliminar el grupo ' + faqGroup.title"
                        title="Eliminar grupo">
                        <i class="material-icons" aria-hidden="true">delete</i>
                      </button>

                    </div>

                  </div>

                  <!-- [animation] va ANTES de [ngbCollapse]: el setter de
                       collapsed lee this.animation al vuelo, así que el orden
                       de los bindings decide si hay transición. Durante el
                       arrastre se apaga para que no corra .collapsing — con las
                       alturas cambiando el CDK calcula mal las posiciones. -->
                  <div
                    [id]="'faqGroupBody' + faqGroup.faqGroupId"
                    [animation]="animateCollapse"
                    [ngbCollapse]="isCollapsed(faqGroup)">

                    <!-- Una zona de arrastre por grupo y SIN conectar con las
                         demás: una pregunta no puede cambiar de grupo, el
                         backend lo rechaza. -->
                    <div
                      cdkDropList
                      cdkDropListLockAxis="y"
                      [cdkDropListDisabled]="reorderingFaqId !== null"
                      (cdkDropListDropped)="dropFaq(faqGroup, $event)"
                      class="platformPage__groupBody platformPage__faqDropList">

                      @for (faq of faqGroup.faqs; track faq.faqId) {

                        <div
                          cdkDrag
                          cdkDragBoundary=".platformPage__faqDropList"
                          cdkDragPreviewContainer="parent"
                          class="platformPage__faq"
                          [ngClass]="{ 'platformPage__faq--off': !faq.status }">
                          <div class="d-flex align-items-start gap-2">

                            <span
                              cdkDragHandle
                              class="platformPage__dragHandle platformPage__dragHandle--faq d-flex align-items-center"
                              title="Arrastra para reordenar esta pregunta dentro del grupo">
                              <i class="material-icons platformPage__dragGrip" aria-hidden="true">drag_indicator</i>
                            </span>

                            <div class="d-flex flex-column platformPage__faqContent">

                              <h4 class="platformPage__faqQuestion mb-1">{{ faq.question }}</h4>

                              <!-- En < lg se oculta la respuesta: la tarjeta se
                                   queda con pregunta + estado, que es lo que se
                                   necesita para decidir. -->
                              <p class="platformPage__faqAnswer mb-2 d-none d-lg-block">{{ faq.answer }}</p>

                              <div class="d-flex flex-wrap align-items-center gap-2">

                                <span
                                  class="platformPage__badge"
                                  [ngClass]="faq.status ? 'platformPage__badge--on' : 'platformPage__badge--off'">
                                  <i class="material-icons platformPage__badgeIcon" aria-hidden="true">
                                    {{ faq.status ? 'visibility' : 'visibility_off' }}
                                  </i>
                                  {{ faq.status ? 'Activa' : 'Inactiva' }}
                                </span>

                                <!-- Activa pero el grupo está apagado: el residente
                                     tampoco la ve. Se dice con texto, no solo con
                                     color. -->
                                @if (faq.status && !faqGroup.status) {
                                  <span class="platformPage__note">
                                    <i class="material-icons platformPage__badgeIcon" aria-hidden="true">info</i>
                                    No se muestra porque el grupo está oculto
                                  </span>
                                }

                                @if (faq.videoUrl) {
                                  <a
                                    [href]="faq.videoUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="platformPage__videoLink"
                                    [attr.aria-label]="'Abrir el video de la pregunta ' + faq.question">
                                    <i class="material-icons platformPage__badgeIcon" aria-hidden="true">play_circle</i>
                                    Video
                                  </a>
                                }

                                @if (reorderingFaqId === faq.faqId) {
                                  <span class="platformPage__saving" aria-hidden="true">
                                    <span class="spinner-border spinner-border-sm"></span>
                                    Guardando orden
                                  </span>
                                }

                                <span class="platformPage__faqMeta d-none d-lg-inline">
                                  Actualizada {{ faq.updatedAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                                </span>

                              </div>

                            </div>

                            <div class="d-flex align-items-center gap-2 ms-auto">

                              <button
                                #moveFaqUpButton
                                (click)="moveFaq(faqGroup, $index, $index - 1, moveFaqUpButton)"
                                type="button"
                                class="btn btn-light rounded-circle platformPage__iconBtn"
                                [ngClass]="{ 'platformPage__iconBtn--off': $first }"
                                [attr.aria-disabled]="$first ? 'true' : null"
                                [attr.aria-label]="'Subir la pregunta ' + faq.question"
                                [title]="$first ? 'Ya es la primera pregunta del grupo' : 'Subir pregunta'">
                                <i class="material-icons" aria-hidden="true">arrow_upward</i>
                              </button>

                              <button
                                #moveFaqDownButton
                                (click)="moveFaq(faqGroup, $index, $index + 1, moveFaqDownButton)"
                                type="button"
                                class="btn btn-light rounded-circle platformPage__iconBtn"
                                [ngClass]="{ 'platformPage__iconBtn--off': $last }"
                                [attr.aria-disabled]="$last ? 'true' : null"
                                [attr.aria-label]="'Bajar la pregunta ' + faq.question"
                                [title]="$last ? 'Ya es la última pregunta del grupo' : 'Bajar pregunta'">
                                <i class="material-icons" aria-hidden="true">arrow_downward</i>
                              </button>

                              <button
                                (click)="openFaq(faqGroup, faq)"
                                type="button"
                                class="btn btn-light rounded-circle platformPage__iconBtn"
                                [attr.aria-label]="'Editar la pregunta ' + faq.question"
                                title="Editar pregunta">
                                <i class="material-icons" aria-hidden="true">edit</i>
                              </button>

                              <button
                                (click)="deleteFaq(faqGroup, faq)"
                                type="button"
                                class="btn btn-danger rounded-circle platformPage__iconBtn"
                                [attr.aria-label]="'Eliminar la pregunta ' + faq.question"
                                title="Eliminar pregunta">
                                <i class="material-icons" aria-hidden="true">delete</i>
                              </button>

                            </div>

                          </div>
                        </div>

                      } @empty {

                        <div class="platformPage__emptyState platformPage__emptyState--inline d-flex flex-column align-items-center justify-content-center text-center">
                          <i class="material-icons platformPage__emptyIcon" aria-hidden="true">help_outline</i>
                          <p class="platformPage__emptyTitle mb-1">Este grupo no tiene preguntas</p>
                          <p class="platformPage__emptyText mb-3">
                            Mientras esté vacío, el grupo no aparece en la pantalla de Ayuda.
                          </p>
                          <button
                            (click)="openFaq(faqGroup)"
                            type="button"
                            class="btn btn-outline-primary platformPage__emptyBtn">
                            Agregar pregunta
                          </button>
                        </div>

                      }

                    </div>
                  </div>

                </div>
              </div>

            } @empty {

              <!-- ---------------------------------------------------------- -->
              <!--                      ANCHOR EMPTY STATE                    -->
              <!-- ---------------------------------------------------------- -->
              <div class="platformPage__panel">
                <div class="platformPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                  <i class="material-icons platformPage__emptyIcon" aria-hidden="true">quiz</i>
                  <p class="platformPage__emptyTitle mb-1">Aún no hay grupos de preguntas</p>
                  <p class="platformPage__emptyText mb-3">
                    Crea el primer grupo — por ejemplo "Pases para visitas" — y dentro
                    agrega las preguntas que verán los residentes en la pantalla de Ayuda.
                  </p>
                  <button
                    (click)="openFaqGroup()"
                    type="button"
                    class="btn btn-outline-primary platformPage__emptyBtn">
                    Crear grupo
                  </button>
                </div>
              </div>

            }

          </div>
        </div>

      }

    }

    <!-- ------------------------------------------------------------------ -->
    <!--                          ANCHOR LIVE REGION                        -->
    <!-- ------------------------------------------------------------------ -->
    <!-- Única región viva de la página. Vive SIEMPRE en el DOM: si apareciera
         junto con su texto el lector de pantalla no la anunciaría. Por aquí
         pasan la carga y cada movimiento de orden. -->
    <div class="col-12 visually-hidden" role="status" aria-live="polite">
      {{ liveMessage }}
    </div>

  </div>
</div>
